import { render, staticRenderFns } from "./ScreenDocumentos.vue?vue&type=template&id=37fa2f96"
import script from "./ScreenDocumentos.vue?vue&type=script&lang=js"
export * from "./ScreenDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports